import React from "react";
import CustomCheckBox from "../../../customCheckBox/customCheckBox";

interface CheckboxCellProps {
  value: { id: string; label: string; isChecked: boolean };
  toggleCheckboxSelection?: (id: string) => void;
  [key: string]: any;
}

export const CheckboxCell: React.FC<CheckboxCellProps> = ({
  value,
  toggleCheckboxSelection,
}) => {
  return (
    <div
      className="table-cell-checkbox flex w-full items-center justify-start"
      onClick={(e) => {
        e.stopPropagation();
        toggleCheckboxSelection?.(value.id);
      }}
    >
      <CustomCheckBox
        id={value.id}
        label={value.label}
        isChecked={value.isChecked}
        onCheckBoxValueChange={() => {}}
        removeGap={true}
      />
    </div>
  );
};

export default CheckboxCell;
